import { CreditsSummaryTotalEntity } from "../entities/CreditSummaryEntity";
import { CreditsRepository } from "../repositories/CreditsRepository";

export class GetVendorCreditsSummaryUseCase {
  constructor(private repository: CreditsRepository) {}

  async execute(autoRefresh?: boolean): Promise<CreditsSummaryTotalEntity> {
    return await this.repository.getVendorCreditsSummary(autoRefresh);
  }
}

